<template>
  <div class="tip-input">
    <label for="tip-input__input" class="iw-body-text-small">
      <span>Enter Tip Amount</span>
      <input
        id="tip-input__input"
        v-model="input"
        placeholder="$0.00"
        type="text"
        class="tip-input__input"
        @blur="isInputActive = false"
        @focus="isInputActive = true"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: "TipInput",
  props: {
    modelValue: Number
  },
  data: function() {
    return {
      isInputActive: false
    };
  },
  computed: {
    input: {
      get: function() {
        const value = this.isInputActive
          ? this.modelValue.toString()
          : "$" + this.modelValue.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
        return parseFloat(value.replace("$", "")) > 0 ? value : "";
      },
      set: function(modifiedValue) {
        let newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ""));

        if (isNaN(newValue)) {
          newValue = 0;
        }

        this.$emit("update:modelValue", newValue);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tip-input {
  background-color: $group-3-color-3-alpha-08;
  width: 100%;
  height: 58px;
  display: flex;
  align-items: center;
  padding: 0 16px;

  &__input {
    margin-left: 24px;
    box-sizing: border-box;
    height: 46px;
    max-width: 64px;
    text-align: center;
    outline: none;
    border: 1px solid $group-3-color-3-alpha-40;
    border-radius: 3px;
    background-color: $group-3-color-1;
    font-size: 14px;
    font-family: $group-3-font-family-1;
    color: $group-3-color-2-alpha-30;

    &:focus {
      border: solid 2px $group-3-color-4;
      border-radius: 3px;
      outline: none !important;
      color: $group-3-color-2;
    }
  }
}
</style>
